import { Injectable } from '@angular/core';
import { BaseService } from '@app/core/services/base/base.service';
import { filter } from 'rxjs/operators';
import { ServerEventService } from '../server-event.service';
import { Inbox } from '@app/shared/models/inbox';

@Injectable({ providedIn: 'root' })
export class InboxWebSocketService extends BaseService {
    public static Events = {
        IMPORTED: 'inboxEntryAccepted',
        DELETED:  'inboxEntryDeleted'
    };

    get inboxSockets() {
        return this._serverEventService.events.pipe(
            filter((event) => [
                InboxWebSocketService.Events.IMPORTED,
                InboxWebSocketService.Events.DELETED
            ].includes(event.event))
        );
    }

    constructor(private _serverEventService: ServerEventService<Inbox>) {
        super();
    }
}
